import React from 'react';
import ContentLoader from 'react-content-loader';
import Styled from '../LoaderStyle';

const LoaderElement: React.FC = (props: any) => (
  <ContentLoader
    speed={2}
    viewBox="0 0 380 100"
    uniqueKey="loader"
    backgroundColor="#f3f3f3"
    foregroundColor="#ccc"
    data-testid="loader"
    {...props}
  >
    <rect x="20" y="20" rx="5" ry="5" width="64" height="63" />
    <rect x="105" y="20" rx="5" ry="5" width="250" height="12" />
    <rect x="105" y="40" rx="5" ry="5" width="180" height="12" />
    <rect x="105" y="60" rx="5" ry="5" width="125" height="12" />
  </ContentLoader>
);

export function ProductListLoader({
  quantity = 4,
  ...props
}: any): JSX.Element {
  return (
    <Styled.Wrapper>
      <Styled.ContentLoaderWrapper>
        {Array.from({ length: quantity }).map((_item, index) => (
          <LoaderElement {...props} index={index} key={index} />
        ))}
      </Styled.ContentLoaderWrapper>
    </Styled.Wrapper>
  );
}
